import { useState } from "react";
import { KeyRound, X } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { ChangePasswordForm } from "@/components/ChangePassword";

export function PasswordExpiryBanner() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [hidden, setHidden] = useState(() => sessionStorage.getItem("pp-pw-banner-hidden") === "1");
  const d = user?.password_expires_in_days;
  if (d == null || d > 7 || hidden) return null;
  const expired = d <= 0;
  return (
    <>
      <div className={`flex flex-wrap items-center gap-2 rounded-md border px-3 py-2 text-xs ${expired ? "border-rose-300 bg-rose-50 text-rose-900" : "border-amber-300 bg-amber-50 text-amber-900"}`} data-testid="password-expiry-banner">
        <KeyRound size={14} />
        <span className="font-semibold">{expired ? "Your password is over 90 days old." : `Your password expires in ${d} day${d === 1 ? "" : "s"}.`}</span>
        <span>{expired ? "Please rotate it now to keep your account secure." : "Rotating it every 90 days keeps your account secure."}</span>
        <button type="button" className="ml-auto pp-btn-primary h-7 px-3 text-xs" onClick={() => setOpen(true)} data-testid="password-expiry-change">Change password</button>
        {!expired && <button type="button" className="pp-btn-ghost h-7 px-2 text-xs" title="Remind me next time" onClick={() => { sessionStorage.setItem("pp-pw-banner-hidden", "1"); setHidden(true); }} data-testid="password-expiry-dismiss"><X size={12} /></button>}
      </div>
      {open && <div className="fixed inset-0 z-[70] flex items-center justify-center bg-slate-900/50 p-4" onClick={() => setOpen(false)}><div className="w-full max-w-md rounded-lg bg-white p-6 shadow-xl" onClick={(e) => e.stopPropagation()}><h3 className="font-display text-lg font-bold mb-3">Change password</h3><ChangePasswordForm onDone={() => setOpen(false)} /></div></div>}
    </>
  );
}
